import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { ReferenceComponent } from './reference.component';


const routes: Routes = [
  {
    path: 'reference',
    component: ReferenceComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class ReferenceRoutingModule {}
